import { render, staticRenderFns } from "./modal-task-link-priority.vue?vue&type=template&id=b2334d18&scoped=true&"
import script from "./modal-task-link-priority.vue?vue&type=script&lang=ts&"
export * from "./modal-task-link-priority.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task-link-priority.vue?vue&type=style&index=0&id=b2334d18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2334d18",
  null
  
)

export default component.exports